import { render, staticRenderFns } from "./EvaluationComponent.vue?vue&type=template&id=6b5e6a12&scoped=true&"
import script from "./EvaluationComponent.vue?vue&type=script&lang=js&"
export * from "./EvaluationComponent.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationComponent.vue?vue&type=style&index=0&id=6b5e6a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e6a12",
  null
  
)

export default component.exports